/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {withResizeDetector} from "react-resize-detector";
/* Components */
import ModalDefault from "../../../common/modal/modal-default";
import PieChart from "../../../common/charts/pie-chart/pie-chart";
import WidgetEmpty from "../empty-widget-content/empty-widget-content";
import Loader from "../../../common/loader/Loader";
import DataChartForm from "./DataChartForm";
/* Services */
import DashboardService /*, {CustomFieldEntity} */ from "../../../../services/dashboard-service";
/* Helpers */
import {formatDataChartData, getSolutionLabel} from "../../../../helpers/chart-helpers";
import {isUserWithDashboardViewerRole} from "../../../../helpers/dashboard-helpers";
import {goToSolutions, shutdownFeed, titleToValueForEnum} from "../widget-helpers";
import isEmpty from "lodash/isEmpty";
import {
    AUDIT_OPTIONS,
    DEVICES_OPTIONS,
    FILE_OPTIONS,
    FILE_SERVER_OPTIONS,
    OS_PLANS_OPTIONS,
    SCHEDULES_OPTIONS,
    REGEX_PARAMS,
} from "./data-chart-options";
//import {DEVICE_CUSTOM_FIELDS} from "../../../../pagingfeed/column-helpers/deviceConstants";
import {SCHEDULE_TYPES} from "../../../../pagingfeed/column-helpers/scheduleConstants";
import {NUMBER_OF_ITEMS_OPTIONS, DATA_TYPE_NAMES, CONTENT_TYPE} from "../widget-constants";
/* Util */
import {
    auditPoliciesColumnConfig,
    deviceManagerDevicesColumnConfig,
    filesColumnConfig,
    fileServersColumnConfig,
    osPlansColumnConfig,
    schedulesColumnConfig,
} from "../../../../pagingfeed/index";

/* Styles */
import "./data-chart.scss";
import IconButton from "../../../common/icon-button/icon-button";
import TextOverflowTooltip from "../../../common/TextOverflowTooltip";
import Tooltip from "rc-tooltip";
import WidgetOptions from "../widget-options/widget-options";

const INITIAL_VALUES = {
    dataType: null,
    filter: {
        humanQuery: {},
        mongoQuery: {},
    },
    chartType: {value: "Pie", label: "Pie", cutout: 0},
    columnsConfig: {},
    dataProperty: null,
};

class DataChart extends React.PureComponent {
    constructor(props) {
        super(props);
        //this.customFieldColumns = {};
        this.scheduleTypes = SCHEDULE_TYPES;
        this._enumInfo = [];
        this.dataFeed = null;
        this.state = {
            formData: {
                title: this.props.data.title,
                numberOfItems: this.props.data.config.numberOfItems || NUMBER_OF_ITEMS_OPTIONS[2],
                dataType: this.props.data.config.dataType || INITIAL_VALUES.dataType,
                filter: this.props.data.config.filter || INITIAL_VALUES.filter,
                chartType: this.props.data.config.chartType || INITIAL_VALUES.chartType,
                dataProperty: this.props.data.config.dataProperty || INITIAL_VALUES.dataProperty,
            },
            tempConfigData: {
                title: this.props.data.title,
                numberOfItems: this.props.data.config.numberOfItems || NUMBER_OF_ITEMS_OPTIONS[3],
                dataType: this.props.data.config.dataType || INITIAL_VALUES.dataType,
                filter: this.props.data.config.filter || INITIAL_VALUES.filter,
                chartType: this.props.data.config.chartType || INITIAL_VALUES.chartType,
                dataProperty: this.props.data.config.dataProperty || INITIAL_VALUES.dataProperty,
                columnsConfig: INITIAL_VALUES.columnsConfig,
            },
            isSettingsModalShown: false,
            columnsConfig: INITIAL_VALUES.columnsConfig,
            dataPropertyOptions: [],
            totalDataCount: null,
            formatedChartData: null,
            cutout: this.props.data.config.cutout || 0,
            isLoadingData: false,
            isLoadingColumnConfig: false,
            errorMessage: "",
            redirectionParam: this.props.data.config.dataProperty
                ? this.props.data.config.dataProperty.value
                : {},
            dataInitialized: false,
        };
    }

    componentDidMount() {
        const dataType = this.state.formData.dataType;
        const dataProperty = this.state.formData.dataProperty;
        const feedFilter = this.state.formData.filter;
        const numberOfItems = this.state.formData.numberOfItems;

        if (dataType) {
            this.initDataFeed(dataType, dataProperty, feedFilter, numberOfItems);
        } else {
            this.setState({isLoadingData: false});
        }

        if (
            dataType !== null &&
            dataType.value === DATA_TYPE_NAMES.DEVICES &&
            dataProperty &&
            !dataProperty.sln
        ) {
            this.handleMissingRedirectionSolution();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.formatedChartData, this.state.formatedChartData)) {
            this.getDataTotalCount();
        }
    }

    componentWillUnmount() {
        //this.customFieldColumns = undefined;

        if (this.dataFeed && typeof this.dataFeed.removeAllListeners === "function") {
            this.dataFeed.removeAllListeners("EntityPropertiesUpdated");
            this.dataFeed.removeAllListeners("EntityAdded");
            this.dataFeed.removeAllListeners("EntityRemoved");
            this.dataFeed.removeAllListeners("ValueUpdated");
        }
        if (this.dataFeed) {
            shutdownFeed(this.dataFeed);
            this.dataFeed = null;
        }
    }

    getDataPropertyOptions = async (dataType) => {
        if (!dataType) {
            return;
        }
        let options;
        let optionsNew;
        let optionsNewArray;

        switch (dataType.value) {
            case DATA_TYPE_NAMES.AUDIT_POLICIES:
                options = AUDIT_OPTIONS;
                break;
            case DATA_TYPE_NAMES.DEVICES:
                try {
                    optionsNew = await deviceManagerDevicesColumnConfig.getColumnConfig();
                } catch (error) {
                    console.log(error);
                }
                optionsNewArray = [];
                for (const [key, value] of Object.entries(optionsNew)) {
                    if (value.groupable === false) {
                        continue;
                    }
                    optionsNewArray.push({
                        sln: "DeviceManager",
                        value: key,
                        label: value.label,
                        dataType: _.get(value, "dataType"),
                        typeInfo: _.get(value, "typeInfo"),
                        enumOptions: _.get(value, "options"),
                    });
                }

                // Merge ConfigDrift/OSManager options not already covered by column config
                DEVICES_OPTIONS.forEach((staticOpt) => {
                    if (!optionsNewArray.some((opt) => opt.value === staticOpt.value)) {
                        optionsNewArray.push(staticOpt);
                    }
                });

                optionsNewArray.sort((a, b) =>
                    a.label.toLowerCase() > b.label.toLowerCase()
                        ? 1
                        : b.label.toLowerCase() > a.label.toLowerCase()
                        ? -1
                        : 0
                );
                options = optionsNewArray;
                break;
            case DATA_TYPE_NAMES.FILE_SERVERS:
                options = FILE_SERVER_OPTIONS;
                break;
            case DATA_TYPE_NAMES.FILES:
                options = FILE_OPTIONS;
                break;
            case DATA_TYPE_NAMES.OS_PLANS:
                options = OS_PLANS_OPTIONS;
                break;
            case DATA_TYPE_NAMES.SCHEDULES:
                options = SCHEDULES_OPTIONS;
                break;
            default:
                options = [];
        }

        this.setState({
            dataPropertyOptions: options,
        });
    };

    changeAllColumnsConfig = async (dataType) => {
        let tempColumnsConfig;

        switch (dataType.value) {
            case DATA_TYPE_NAMES.AUDIT_POLICIES:
                tempColumnsConfig = auditPoliciesColumnConfig;
                break;
            case DATA_TYPE_NAMES.DEVICES:
                tempColumnsConfig = await this.getSpreadedColumnConfig(
                    dataType,
                    await deviceManagerDevicesColumnConfig.getColumnConfig()
                );
                break;
            case DATA_TYPE_NAMES.FILES:
                tempColumnsConfig = await this.getSpreadedColumnConfig(dataType, filesColumnConfig);
                break;
            case DATA_TYPE_NAMES.FILE_SERVERS:
                tempColumnsConfig = fileServersColumnConfig;
                break;
            case DATA_TYPE_NAMES.OS_PLANS:
                tempColumnsConfig = osPlansColumnConfig;
                break;
            case DATA_TYPE_NAMES.SCHEDULES:
                tempColumnsConfig = schedulesColumnConfig;
                break;
            default:
                tempColumnsConfig = INITIAL_VALUES.columnsConfig;
        }

        return _.cloneDeep(tempColumnsConfig);
    };

    async getSpreadedColumnConfig(dataType, columnConfig) {
        if (!_.isEmpty(columnConfig)) {
            const columnConfigCopy = await _.cloneDeep(columnConfig);
            switch (dataType.value) {
                case DATA_TYPE_NAMES.DEVICES:
                    this.customFieldColumns = await DashboardService.getCustomFields();
                    // TODO: Custom field columns disabled - reducer computed but not applied
                    // See _.assign below. Re-enable when custom fields feature is ready.
                    /*
                    const enabledCustomColumns = Object.entries(this.customFieldColumns).reduce(
                        customColumnsReduceFunction,
                        []
                    );
                    */
                    if (columnConfigCopy.detectedOs) {
                        columnConfigCopy.detectedOs.options = this.props.osMap;
                    }
                    if (columnConfigCopy.fileServerName) {
                        columnConfigCopy.fileServerName.options = this.props.fileServersMap;
                    }
                    //_.assign(columnConfigCopy, ...enabledCustomColumns);
                    break;
                case DATA_TYPE_NAMES.FILES:
                    columnConfigCopy.pathId.context.osImagePaths = this.props.osPaths;
                    break;
                default:
                    break;
            }
            return columnConfigCopy;
        }
        // Return empty object for consistency with cloneDeep above
        return {};
    }

    setDataFeedState = (dataType, dataProperty, numberOfItems) => {
        let dataFeedState = this.dataFeed.getValuesCounts();
        if (Array.isArray(this._enumInfo) && this._enumInfo.length) {
            const options = this._enumInfo;
            const getLabelFromOptions = (value) => {
                const option = _.find(
                    options,
                    (opt) => String(_.get(opt, "value")) === String(value)
                );
                return _.get(option, "title", value);
            };

            dataFeedState = Object.entries(dataFeedState).reduce(
                (chartData, [propName, propValue]) => {
                    const mappedName = getLabelFromOptions(propName);
                    const safeName = String(mappedName).trim() === "" ? "Blank" : mappedName;
                    //aggrigates all values for a property (important when null, undefined, "" are valid values)
                    const current = _.get(chartData, safeName, 0);
                    return {...chartData, [safeName]: current + propValue};
                },
                {}
            );
        }

        if (dataType.value === DATA_TYPE_NAMES.SCHEDULES) {
            dataFeedState = Object.entries(dataFeedState).reduce(
                (chartData, [propName, propValue]) => {
                    const propertyData = this.scheduleTypes[propName]
                        ? {name: this.scheduleTypes[propName].title, value: propValue}
                        : {name: propName, value: propValue};
                    return {...chartData, [propertyData.name]: propertyData.value};
                },
                {}
            );
        }

        const chartData = this.handleFormatChartData(
            dataFeedState,
            numberOfItems,
            this.props.isLightThemeActive,
            _,
            dataType.value,
            dataProperty.value
        );

        this.setState((state) => {
            const newState = {
                ...state,
            };

            newState.formatedChartData = chartData;

            newState.isLoadingData = false;
            newState.dataInitialized = true;

            return newState;
        });
    };

    handleFormatChartData = (
        chartData,
        numberOfItems,
        isLightThemeActive,
        _,
        dataTypeValue,
        dataPropertyValue
    ) => {
        const dataType = this.state.formData.dataType
            ? this.state.formData.dataType.value
            : this.state.tempConfigData.dataType.value;
        const formatedChartData = formatDataChartData(
            chartData,
            numberOfItems,
            dataType,
            isLightThemeActive,
            dataTypeValue,
            dataPropertyValue
        );

        return formatedChartData;
    };

    initDataFeed = async (dataType, dataProperty, feedFilter, numberOfItems) => {
        this.dataFeed = await this.feedFactory(dataType, dataProperty, feedFilter, () =>
            this.setDataFeedState(dataType, dataProperty, this.state.formData.numberOfItems)
        );

        this.setDataFeedState(dataType, dataProperty, numberOfItems);
    };

    formatDeviceFeedFilters = (dataProperty, filter) => {
        let filterQuery = {};
        if (dataProperty.sln && dataProperty.sln === "ConfigDrift") {
            filterQuery = {
                $userQuery: filter.mongoQuery || filter,
                $systemQuery: {managementState: {$in: ["MANAGED", "UNMANAGED"]}},
            };
        } else {
            filterQuery = {
                $userQuery: filter.mongoQuery || filter,
                $systemQuery: {},
            };
        }
        return filterQuery;
    };

    feedFactory = async (dataType, dataProperty, feedFilter, onFeedChange) => {
        let feed = null;

        const enumColConfigs = await deviceManagerDevicesColumnConfig.getColumnConfig();
        this._enumInfo = _.get(enumColConfigs, [_.get(dataProperty, "value"), "options"], []);

        switch (dataType.value) {
            case DATA_TYPE_NAMES.AUDIT_POLICIES:
                feed = await DashboardService.getAuditPoliciesDistinctValues(
                    dataProperty.value,
                    feedFilter
                );
                break;
            case DATA_TYPE_NAMES.OS_PLANS:
                feed = await DashboardService.getOsPlansDistinctValues(
                    dataProperty.value,
                    feedFilter
                );
                break;
            case DATA_TYPE_NAMES.DEVICES:
                const deviceFeedFilter = this.formatDeviceFeedFilters(dataProperty, feedFilter);
                feed = await DashboardService.getDevicesDistinctValues(
                    dataProperty.value,
                    deviceFeedFilter
                );
                break;
            case DATA_TYPE_NAMES.FILE_SERVERS:
                feed = await DashboardService.getFileServersDistinctValues(
                    dataProperty.value,
                    feedFilter
                );
                break;
            case DATA_TYPE_NAMES.FILES:
                feed = await DashboardService.getFilesDistinctValues(
                    dataProperty.value,
                    feedFilter
                );
                break;
            case DATA_TYPE_NAMES.SCHEDULES:
                feed = await DashboardService.getSchedulesDistinctValues(
                    dataProperty.value,
                    feedFilter
                );
                break;
            default:
                feed = null;
        }

        if (
            dataType.value === DATA_TYPE_NAMES.FILES ||
            dataType.value === DATA_TYPE_NAMES.FILE_SERVERS
        ) {
            feed.on("EntityAdded", onFeedChange);
            feed.on("EntityRemoved", onFeedChange);
            feed.on("EntityPropertiesUpdated", onFeedChange);
        } else {
            feed.on("ValueUpdated", onFeedChange);
        }
        return feed;
    };

    getDataTotalCount = () => {
        const totalDataCount = this.state.formatedChartData.datasets[0].data.reduce(
            (acc, val) => acc + val,
            0
        );
        this.setState({
            totalDataCount,
        });
    };

    toggleSettingsModal = async (e) => {
        e.stopPropagation();

        let tempColumnsConfig = {};

        const dataType = this.state.formData.dataType;
        if (dataType) {
            tempColumnsConfig = await this.changeAllColumnsConfig(dataType);
            this.getDataPropertyOptions(dataType);
        }

        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                filter: {...this.state.formData.filter},
                columnsConfig: tempColumnsConfig,
                dataType: {...dataType},
            },
            isSettingsModalShown: !this.state.isSettingsModalShown,
        });
    };

    handleSave = async (values) => {
        const dataType = values.dataType;
        const stateDataType = this.state.formData.dataType;
        const dataProperty = values.dataProperty;
        const stateDataProperty = this.state.formData.dataProperty;
        const filter = values.filter;
        const stateFilter = this.state.formData.filter;
        const numberOfItems = values.numberOfItems;
        const stateNumberOfItems = this.state.formData.numberOfItems;

        this.setState({
            isSettingsModalShown: false,
            isLoadingData: true,
        });

        if (
            (stateDataType && stateDataType.value !== dataType.value) ||
            (stateDataProperty && stateDataProperty.value !== dataProperty.value) ||
            !_.isEqual(stateFilter, filter.mongoQuery)
        ) {
            if (this.dataFeed) {
                await shutdownFeed(this.dataFeed);
                this.dataFeed = null;
            }
            await this.initDataFeed(dataType, dataProperty, filter, numberOfItems);
        }

        if (numberOfItems !== stateNumberOfItems) {
            this.setDataFeedState(dataType, dataProperty, numberOfItems);
        }

        this.setState(
            (state) => {
                const newState = {
                    ...state,
                };
                newState.formData = values;
                newState.isSettingsModalShown = false;
                newState.columnsConfig = this.state.tempConfigData.columnsConfig;
                newState.cutout = values.chartType.cutout;
                newState.redirectionParam = values.dataProperty.value;
                newState.isLoadingData = false;
                newState.dataInitialized = true;

                return newState;
            },
            () => {
                this.props.onUpdate({
                    ...this.props.data,
                    title: this.state.formData.title,
                    config: {
                        ...this.props.data.config,
                        numberOfItems: this.state.formData.numberOfItems,
                        dataType: this.state.formData.dataType,
                        dataProperty: this.state.formData.dataProperty,
                        chartType: this.state.formData.chartType,
                        filter: this.state.formData.filter,
                        cutout: this.state.cutout,
                        redirectionParam: this.state.redirectionParam,
                    },
                });
            }
        );
    };

    reduceColumnConfig(columnConfig) {
        const obj = {};
        Object.entries(columnConfig).forEach((el) => {
            obj[el[0]] = {shown: el[1].shown, priority: el[1].priority};
        });

        return obj || {};
    }

    handleDataTypeChange = (field, props) => async (value) => {
        this.setState({isLoadingColumnConfig: true});
        const tempColumnsConfig = await this.changeAllColumnsConfig(value);
        await this.getDataPropertyOptions(value);

        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                columnsConfig: tempColumnsConfig,
                [field]: value,
                filter: INITIAL_VALUES.filter,
            },
            isLoadingColumnConfig: false,
        });
        props.setFieldValue(field, value);
        props.setFieldValue("filter", INITIAL_VALUES.filter);
        props.setFieldValue("dataProperty", INITIAL_VALUES.dataProperty);
        props.setFieldValue("filterName", INITIAL_VALUES.filterName);
    };

    handleFormFieldChange = (field, props) => (value) => {
        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                [field]: value,
            },
        });
        props.setFieldValue(field, value);
    };

    handleChartRedirect = () => {
        const openSolutionInNewTab = this.props.openSolutionsInNewTab;

        if (this.props.isMobileDevice) {
            return;
        }
        let obj = {
            filter: INITIAL_VALUES.filter,
        };
        if (Object.keys(this.state.formData.filter).length > 0) {
            obj = {
                ...obj,
                filter: this.state.formData.filter.mongoQuery,
            };
        }
        if (this.state.formData.dataType.value === DATA_TYPE_NAMES.DEVICES) {
            obj = {
                ...obj,
                groupingField: this.state.redirectionParam,
            };
        }
        goToSolutions(
            obj,
            this.state.formData.dataType.value,
            this.props.isMobileDevice,
            this.state.formData.dataProperty.sln,
            openSolutionInNewTab
        );
    };

    getDataTypesForRedirectionParam = (param) => {
        if (this.isCustomField(param)) {
            param = "reg";
        }

        if (this.state.formData.dataType.value === "OS_PLANS" && param === "status") {
            return [];
        }

        switch (param) {
            case "lastAuditStatus":
                return [DATA_TYPE_NAMES.AUDIT_POLICIES];
            case "reg":
                return [DATA_TYPE_NAMES.DEVICES];
            case "status":
                return [DATA_TYPE_NAMES.FILE_SERVERS, DATA_TYPE_NAMES.FILES];
            case "solution":
                return [DATA_TYPE_NAMES.SCHEDULES];
            default:
                return [];
        }
    };

    isCustomField = (input) => {
        return input.match(
            "^customFieldValues.[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        );
    };

    getSchedulesType = (label) => {
        const type = Object.keys(this.scheduleTypes).find(
            (type) => this.scheduleTypes[type].title === label
        );
        return type;
    };

    checkQueryLabel = (redirectionParam, label, dataTypes) => {
        if (label === "Other") {
            return this.getNotFilter(redirectionParam);
        }
        if (dataTypes.includes(this.state.formData.dataType.value)) {
            return {$and: [{[redirectionParam]: {$eq: label}}]};
        }
        return null;
    };

    checkRedirectionOperator = (label) => {
        let redirectionParam = label;
        REGEX_PARAMS.forEach((item) => {
            if (label === item) {
                redirectionParam = "reg";
            }
        });
        return redirectionParam;
    };

    getRedirectionFilter = (label) => {
        if (!this.state.redirectionParam) {
            return null;
        }

        const redirectionParam = this.checkRedirectionOperator(this.state.redirectionParam);
        const redirectionDataTypes = this.getDataTypesForRedirectionParam(redirectionParam);

        let clickedFilter;
        if (!redirectionDataTypes.length) {
            // Fallback: direct equality filter for properties not in the explicit type mapping.
            // Reverse-map the display title back to the DB value for enum fields.
            const filterValue = titleToValueForEnum(label, this._enumInfo);
            clickedFilter = {$and: [{[this.state.redirectionParam]: {$eq: filterValue}}]};
        } else {
            clickedFilter = this.checkQueryLabel(
                this.state.redirectionParam,
                label,
                redirectionDataTypes
            );
            if (!clickedFilter) {
                return null;
            }
        }

        // Merge with base chart filter — flatten $and conditions to avoid double-nesting
        const baseFilter = this.state.formData.filter?.mongoQuery;
        if (baseFilter) {
            const conditions = clickedFilter.$and || [clickedFilter];
            return {$and: [...conditions, baseFilter]};
        }

        return clickedFilter;
    };

    handleSingleLabelRedirection = (label) => {
        const openSolutionInNewTab = this.props.openSolutionsInNewTab;

        if (this.props.isEditAllowed || isUserWithDashboardViewerRole()) {
            return;
        }

        if (
            this.state.formData.dataType.value === DATA_TYPE_NAMES.SCHEDULES &&
            this.state.redirectionParam === "schedule.type"
        ) {
            label = this.getSchedulesType(label);
        }

        if (String(label) === "Blank") {
            label = "";
        }

        const currentDataPropertyDataType = _.get(this.state.formData.dataProperty, "dataType", "");
        if (currentDataPropertyDataType === "number" && !_.isEmpty(label)) {
            const numericValue = Number(label);
            if (!Number.isNaN(numericValue)) {
                label = numericValue;
            }
        }

        let obj = {
            filter: this.getRedirectionFilter(label),
        };

        if (this.state.formData.dataType.value === DATA_TYPE_NAMES.DEVICES) {
            obj = {
                ...obj,
                groupingField: {},
            };
        }

        goToSolutions(
            obj,
            this.state.formData.dataType.value,
            this.props.isMobileDevice,
            this.state.formData.dataProperty.sln,
            openSolutionInNewTab
        );
    };

    getNotFilter = (redirectionParam) => {
        const escapeRegExp = (str) =>
            typeof str === "string" ? str.replace(/[\\[\]/{}()*+?.^$|-]/g, "\\$&") : str;

        const filter = this.state.formatedChartData.labels
            .filter((group) => group !== "Other" && group !== "")
            .map((group) =>
                escapeRegExp(group) !== "undefined"
                    ? {
                          [redirectionParam]: {
                              $options: "i",
                              $regex: `^(?!${escapeRegExp(group)}$).*$`,
                          },
                      }
                    : {
                          [redirectionParam]: {$ne: ""},
                      }
            );
        return {$and: filter};
    };

    handleMissingRedirectionSolution = () => {
        const dataProperty = DEVICES_OPTIONS.find(
            (item) => this.state.formData.dataProperty.value === item.value
        );
        if (!dataProperty) {
            return;
        }
        this.setState({
            formData: {
                ...this.state.formData,
                dataProperty: {
                    ...this.state.formData.dataProperty,
                    sln: dataProperty.sln,
                },
            },
        });
    };

    getContentType = () => {
        if (this.state.errorMessage) {
            return CONTENT_TYPE.ERROR;
        }
        if (!this.state.dataInitialized && !this.state.formData.dataType) {
            return CONTENT_TYPE.NOT_INITIALIZED;
        }
        if (
            !this.state.formatedChartData ||
            isEmpty(this.state.formatedChartData) ||
            !this.state.formatedChartData.datasets[0].data.length
        ) {
            return CONTENT_TYPE.EMPTY;
        }
        return CONTENT_TYPE.DATA;
    };

    getEmptyMessage = () => {
        if (!this.state.formData.dataType) {
            return "The initial widget configuration is empty";
        }
        if (
            this.state.formData.filter.mongoQuery &&
            this.state.formatedChartData &&
            this.state.formatedChartData.datasets[0].data.length === 0
        ) {
            return "Filters criteria were not matched";
        }
        if (this.state.formData.filter && !this.state.formData.filter.mongoQuery) {
            return "No data for specified configuration";
        }
        return "The initial widget configuration is empty";
    };

    renderContent = () => {
        switch (this.getContentType()) {
            case CONTENT_TYPE.ERROR:
                return (
                    <WidgetEmpty
                        isEditAllowed={this.props.isEditAllowed}
                        showSettingsModal={this.toggleSettingsModal}
                        text={this.state.errorMessage || "Something went wrong."}
                    />
                );
            case CONTENT_TYPE.NOT_INITIALIZED:
            case CONTENT_TYPE.EMPTY:
                return (
                    <WidgetEmpty
                        isEditAllowed={this.props.isEditAllowed}
                        showSettingsModal={this.toggleSettingsModal}
                        text={this.getEmptyMessage()}
                    />
                );
            case CONTENT_TYPE.DATA:
                return (
                    <>
                        <div
                            className="
                        glu-content__section
                        glu-content__separator
                        glu-content__separator--inner
                        glu-data-chart"
                        >
                            <div className="glu-data-chart glu-flex">
                                <PieChart
                                    data={this.state.formatedChartData}
                                    cutoutPercentage={this.state.cutout}
                                    singleLabelRedirect={this.handleSingleLabelRedirection}
                                />
                            </div>
                        </div>
                        <div className="glu-content__section glu-data-chart__total glu-pad--lg">
                            Total: <span>{this.state.totalDataCount}</span>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    render() {
        const dataTypeValue = this.state.formData.dataType
            ? this.state.formData.dataType.value
            : "";
        return (
            <>
                <div className="glu-dashboard-card glu-content">
                    {(this.state.isLoadingData ||
                        (!this.state.dataInitialized &&
                            this.state.formData.dataType &&
                            this.state.formData.dataType.value)) && <Loader />}
                    <div className="glu-content__header">
                        {this.props.isEditAllowed && (
                            <div className="glu-flex-shrink">
                                <IconButton
                                    className="glu-icon__draggable cursor-move"
                                    icon="drag"
                                />
                            </div>
                        )}
                        <TextOverflowTooltip
                            title={this.state.formData.title}
                            height={this.props.height}
                            width={this.props.width}
                            renderChildren={(ref) => (
                                <div className="glu-flex-grow">
                                    <div className="glu-page__title glu-widget-title" ref={ref}>
                                        {this.state.formData.title}
                                    </div>
                                </div>
                            )}
                        />
                        <div className="glu-flex-row">
                            {!isEmpty(this.state.formatedChartData) &&
                                !this.props.isEditAllowed &&
                                !this.props.isMobileDevice &&
                                !isUserWithDashboardViewerRole() && (
                                    <div className="glu-flex-shrink">
                                        <Tooltip
                                            placement="top"
                                            trigger={["hover"]}
                                            overlay={
                                                <span>
                                                    Open in {getSolutionLabel(dataTypeValue)}
                                                </span>
                                            }
                                        >
                                            <button className="glu-btn-link glu-tooltip">
                                                <IconButton
                                                    icon="exit-from-the-app"
                                                    onClick={this.handleChartRedirect}
                                                />
                                            </button>
                                        </Tooltip>
                                    </div>
                                )}

                            {this.props.isEditAllowed && (
                                <WidgetOptions
                                    showWidgetInfo={this.props.showWidgetInfo(this.props.data)}
                                    openConfiguration={this.toggleSettingsModal}
                                    onRemove={this.props.onRemove(this.props.data)}
                                    onClone={this.props.onClone(this.props.data)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="glu-content__body">{this.renderContent()}</div>
                </div>
                {this.state.isSettingsModalShown && (
                    <ModalDefault isOpen={this.state.isSettingsModalShown}>
                        <div className="glu-modal-content">
                            <div className="glu-modal__header">
                                <div className="glu-modal__title glu-flex-grow">
                                    {this.state.formData.title}
                                </div>
                                <div className="glu-flex-shrink">
                                    <button
                                        aria-label="close"
                                        type="button"
                                        className="glu-btn-link g-icon g-icon-close"
                                        onClick={this.toggleSettingsModal}
                                    />
                                </div>
                            </div>
                            <DataChartForm
                                initialValues={this.state.formData}
                                onFormSubmit={this.handleSave}
                                handleFormFieldChange={this.handleFormFieldChange}
                                handleDataTypeChange={this.handleDataTypeChange}
                                dataPropertyOptions={this.state.dataPropertyOptions}
                                tempConfigData={this.state.tempConfigData}
                                onCancel={this.toggleSettingsModal}
                                isLoadingColumnConfig={this.state.isLoadingColumnConfig}
                            />
                        </div>
                    </ModalDefault>
                )}
            </>
        );
    }
}

DataChart.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    isEditAllowed: PropTypes.bool,
    isLightThemeActive: PropTypes.bool.isRequired,
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
    showWidgetInfo: PropTypes.func,
    onClone: PropTypes.func,
    osMap: PropTypes.arrayOf(PropTypes.any),
    osPaths: PropTypes.objectOf(PropTypes.any),
    fileServersMap: PropTypes.arrayOf(PropTypes.any),
    selectedOrganization: PropTypes.objectOf(PropTypes.any),
    isMobileDevice: PropTypes.bool,
};

DataChart.defaultProps = {
    isEditAllowed: false,
    onRemove: undefined,
    onUpdate: undefined,
    showWidgetInfo: undefined,
    onClone: undefined,
    osMap: [],
    osPaths: {},
    fileServersMap: [],
    selectedOrganization: null,
    isMobileDevice: false,
};

export default withResizeDetector(DataChart);
